const SectionHeader = ({ title, subtitle }) => {
  return (
    <div className="mb-12">
      <h2 className="text-4xl font-bold text-blue-900 relative inline-block">
        {title}
        <span className="absolute bottom-0 left-0 w-1/2 h-1 bg-blue-600 rounded-full"></span>
      </h2>
      {subtitle && <p className="text-gray-600 mt-4 text-lg">{subtitle}</p>}
    </div>
  );
};

export default SectionHeader;